import { EUpdateModalTitle, EUpdateModalButton, EUpdateModalSubTitle } from 'lib/storage';
import { AnyAction } from 'redux';
import { IAddNewUpdateState, EAddNewUpdateActionType } from './types';

const buildInitialState = (): IAddNewUpdateState => ({
  isModalOpen: false,
  updateIds: '',
  isPostUpdateModalOpen: false,
  isDeleteUpdateModalOpen: false,
  editorhtml: '',
  isPostUpdateConfirmButtonPressed: false,
  title: '',
  modalTitle: EUpdateModalTitle.NEW_UPDATE,
  updateModalButtonTittle: EUpdateModalButton.NEW_UPDATE,
  updateModalSubTitle: EUpdateModalSubTitle.NEW_UPDATE,
  productReleaseObj: { title: '', description: '', id: '' },
  productReleases: [],
  isDeleteProduct: false,
  isAddProduct: false,
  isProductReleasesFetched: false,
});

const AddNewUpdateReducer = (state = buildInitialState(), action: AnyAction): IAddNewUpdateState => {
  switch (action.type) {
    case EAddNewUpdateActionType.SET_IS_MODAL_OPEN_ADD_NEW: {
      return {
        ...state,
        isModalOpen: action.payload.isModalOpen,
        modalTitle: action.payload.modalTitle,
        updateModalButtonTittle: action.payload.updateModalButtonTittle,
        updateModalSubTitle: action.payload.updateModalSubTitle,
        productReleaseObj: action.payload.productReleaseObj,
      };
    }

    case EAddNewUpdateActionType.SET_IS_UPDATE_MODAL_OPEN:
    case EAddNewUpdateActionType.SET_CONFIRM_IS_MODAL_OPEN_ADD_NEW: {
      return {
        ...state,
        isPostUpdateModalOpen: action.payload.isPostUpdateModalOpen,
      };
    }

    case EAddNewUpdateActionType.SET_UPDATE_IDS: {
      return {
        ...state,
        updateIds: action.payload,
      };
    }

    case EAddNewUpdateActionType.SAVE_EDITOR_DATA:
      return {
        ...state,
        editorhtml: action.payload,
      };

    case EAddNewUpdateActionType.POST_UPDATE_CONFIRM_BUTTON_PRESSED:
      return {
        ...state,
        isPostUpdateConfirmButtonPressed: action.payload.isPostUpdateConfirmButtonPressed,
      };

    case EAddNewUpdateActionType.SET_UPDATE_TITLE:
      return {
        ...state,
        title: action.payload.title,
      };

    case EAddNewUpdateActionType.SET_DELETE_UPDATE_IS_MODAL_OPEN_ADD_NEW:
      return {
        ...state,
        isDeleteUpdateModalOpen: action.payload.isDeleteUpdateModalOpen,
      };
    case EAddNewUpdateActionType.GET_PRODUCT_UPDATES_SUCCESS:
      return {
        ...state,
        productReleases: action.payload,
        isDeleteProduct: false,
        isAddProduct: false,
        isProductReleasesFetched: true,
      };
    case EAddNewUpdateActionType.DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        isDeleteProduct: true,
        isProductReleasesFetched: false,
      };

    case EAddNewUpdateActionType.UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        isAddProduct: true,
        isProductReleasesFetched: false,
      };

    default: {
      return state;
    }
  }
};

export default AddNewUpdateReducer;
